
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/export_trades",
      function () {
        return require("private-next-pages/admin/export_trades.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/export_trades"])
      });
    }
  